import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";
// import Button from "../components/Buttons";

// import { useUserContext } from "../../contexts/UserContext";
// import { useLoadContext } from "../../contexts/LoadContext";
import Button from "../components/Buttons";
import { Colors } from "../ColorConstants";
import { Text } from "../TextConstants";
import { Validation } from "../helper";
import { userCreatePassword } from "../services/userServices";
import { toast } from "react-toastify";
import ToastMessage from "../components/ToastMessage";
import { trackFBEvent } from "../analytics";
import { EVENT } from "../analytics/constants";
const loginBg = require("../assets/images/Loginbg.png");

const CreatePin = () => {
  let navigate = useNavigate();
  let [searchParams] = useSearchParams();
  let data = searchParams.get("email");

  const [otpComplete, setOTPComplete] = useState(false);
  const [otp, setOtp] = useState(new Array(4).fill(""));
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState();
  const [error, setError] = useState({
    otp: "",
  });

  useEffect(() => {
    trackFBEvent(EVENT.CURRENT_SCREEN, { page: "Create Pin Page" });
  }, []);

  const handleChange = (element, index) => {
    console.log(element.value.length);
    if (element.value.length <= 1) {
      setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);
    }
    setOTPComplete(false);
    if (isNaN(element.value)) return false;

    console.log(otp);
    if (element.value !== "" && element.nextSibling) {
      element.nextSibling.focus();
    }
    if (element.value === "" && index > 0) {
      // Focus on the previous field
      element.previousSibling.focus();
    }
  };

  const handleSubmit = (e) => {
    setOTPComplete(false);
    e.preventDefault();
    let otpFinal = otp.join("");
    let user;
    user = { pin: otpFinal, userId: userId };
    if (otp.join("").length === 4) {
      createPassword(user);
    } else {
      setOTPComplete(true);
    }
  };

  const createPassword = async (user) => {
    setLoading(true);
    try {
      const response = await userCreatePassword(user);
      if (response.status === 200) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("type", response.data.userType);
        localStorage.removeItem("guestId");
        localStorage.setItem("name", response.data.name);
        toast.success(response.data.message, { hideProgressBar: true });
        navigate("/auth/home");
      }
    } catch (error) {
      if (navigator.onLine) {
        toast.error(error.message, { hideProgressBar: true });
      } else {
        toast.error(
          <ToastMessage
            message="You're offline now"
            subMessage="Oops! Internet is disconnected."
          />,
          {
            hideProgressBar: true,
          }
        );
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    const UserValue = localStorage.getItem("userID");
    if (UserValue) {
      setUserId(UserValue);
    }
  }, []);

  return (
    <VerifyOtpStyled>
      <VerifyOtpModal>
        <InnerDiv>
          <Logo src={require("../assets/images/lww_logo.png")} alt="logo" />
          <HeaderRight>{Text.verifyOtpHeader}</HeaderRight>
          {/* <SubHeaderRight>{Text.verifyOtpSubHeader}</SubHeaderRight> */}

          <VerifyOtpForm>
            <VerifyOtpContainer>
              {otp.map((data, index) => {
                return (
                  <VerifyOtpInput
                    type="password"
                    name="otp"
                    maxLength="2"
                    key={index}
                    value={data}
                    onChange={(e) => handleChange(e.target, index)}
                    onFocus={(e) => e.target.select()}
                  />
                );
              })}
            </VerifyOtpContainer>
            {otpComplete && <ErrorMessage>{Text.otpInput}</ErrorMessage>}
            <AddSpace>
              <Button
                disabled={otp.join("").length < 4}
                backgroundColor={
                  otp.join("").length < 4 ?Colors.aqua : Colors.aqua
                }
                fontColor={otp.join("").length < 4 ? "#919191" : Colors.white}
                label="Submit"
                variant="filled"
                color={Colors.aqua}
                size="large"
                onClick={(e) => handleSubmit(e)}
              />
            </AddSpace>
          </VerifyOtpForm>
        </InnerDiv>
      </VerifyOtpModal>
    </VerifyOtpStyled>
  );
};

export default CreatePin;

const VerifyOtpStyled = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-image: url(${loginBg}); */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;
const VerifyOtpModal = styled.div`
  width: 32rem;
  height: 32.3rem;
  border-radius: 0.5rem;
  padding: 0 1rem;
  background: ${Colors.whiteSmoke};
  @media only screen and (max-width: 768px) {
    width: 100%;
    height: 100vh;
    border-radius: 0;
    display: flex;
    justify-content: center;
    padding: 0;
  }
`;
const InnerDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Logo = styled.img`
  margin-top: 1rem;
  width: 22rem;
  resize: contain;
  @media only screen and (max-width: 768px) {
    margin: 2rem 0;
    width: 100%;
  }
`;
const HeaderRight = styled.div`
  font-family: "Poppins";
  font-size: 2rem;
  color: ${Colors.black};
  margin-top: 1.2rem;
  margin-bottom: 2rem;
  text-align: center;
  @media only screen and (max-width: 768px) {
    font-size: 1.5rem;
  }
`;
const SubHeaderRight = styled.div`
  font-family: "Poppins";
  font-size: 0.875rem;
  color: ${Colors.mischkaApprox};
  text-align: center;
  margin-top: 1.25rem;
  margin-bottom: 3rem;
  padding: 0 1rem;
`;
const VerifyOtpForm = styled.form`
  width: 20rem;
  height: 12rem;
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 768px) {
    width: 90%;
  }
`;
const VerifyOtpContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;
const VerifyOtpInput = styled.input`
  border-radius: 0.5rem;
  background: #fcfdfe;
  border: 1px solid #eee;
  width: 3rem;
  height: 2.5rem;
  font-family: "Poppins";
  font-size: 2rem;
  text-align: center;
`;
const ErrorMessage = styled.div`
  font-family: "Poppins";
  font-size: 0.75rem;
  color: ${Colors.coralRedApprox};
  position: absolute;
  margin-top: 0.25rem;
`;

const AddSpace = styled.span`
  margin-top: 4rem;
  margin-bottom: 1rem;
`;
